module.exports = __webpack_public_path__ + "static/media/home.1889e486.svg";